module.exports = __webpack_public_path__ + "static/media/full.55a68082.svg";